// extracted by mini-css-extract-plugin
export default {"myInput":"MyInput_myInput__P7zZi","fadeIn":"MyInput_fadeIn__uEzYY"};